"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Bus_1 = require("./Bus");
/**
 * A bus that indexes identified actors,
 * so that actions with a corresponding identifier can be published more efficiently.
 *
 * Multiple actors with the same identifier can be subscribed.
 *
 * If actors or actions do not have a valid identifier,
 * then this will fallback to the normal bus behaviour.
 *
 * @see Bus
 *
 * @template A The actor type that can subscribe to the sub.
 * @template I The input type of an actor.
 * @template T The test type of an actor.
 * @template O The output type of an actor.
 */


var BusIndexed =
/*#__PURE__*/
function (_Bus_1$Bus) {
  _inherits(BusIndexed, _Bus_1$Bus);

  /**
   * All enumerable properties from the `args` object are inherited to this bus.
   *
   * @param {IBusIndexedArgs} args Arguments object
   * @param {string} args.name The name for the bus
   * @throws When required arguments are missing.
   */
  function BusIndexed(args) {
    var _this;

    _classCallCheck(this, BusIndexed);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BusIndexed).call(this, args));
    _this.actorsIndex = {};
    return _this;
  }

  _createClass(BusIndexed, [{
    key: "subscribe",
    value: function subscribe(actor) {
      var actorId = this.getActorIdentifier(actor) || '_undefined_';
      var actors = this.actorsIndex[actorId];

      if (!actors) {
        actors = this.actorsIndex[actorId] = [];
      }

      actors.push(actor);

      _get(_getPrototypeOf(BusIndexed.prototype), "subscribe", this).call(this, actor);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(actor) {
      var actorId = this.getActorIdentifier(actor) || '_undefined_';
      var actors = this.actorsIndex[actorId];

      if (actors) {
        var i = actors.indexOf(actor);

        if (i >= 0) {
          actors.splice(i, 1);
        }

        if (actors.length === 0) {
          delete this.actorsIndex[actorId];
        }
      }

      return _get(_getPrototypeOf(BusIndexed.prototype), "unsubscribe", this).call(this, actor);
    }
  }, {
    key: "publish",
    value: function publish(action) {
      var actionId = this.getActionIdentifier(action);

      if (actionId) {
        var actors = (this.actorsIndex[actionId] || []).concat(this.actorsIndex._undefined_ || []);
        return actors.map(function (actor) {
          return {
            actor: actor,
            reply: actor.test(action)
          };
        });
      } else {
        return _get(_getPrototypeOf(BusIndexed.prototype), "publish", this).call(this, action);
      }
    }
  }, {
    key: "getActorIdentifier",
    value: function getActorIdentifier(actor) {
      return this.actorIdentifierFields.reduce(function (object, field) {
        return object[field];
      }, actor);
    }
  }, {
    key: "getActionIdentifier",
    value: function getActionIdentifier(action) {
      return this.actionIdentifierFields.reduce(function (object, field) {
        return object[field];
      }, action);
    }
  }]);

  return BusIndexed;
}(Bus_1.Bus);

exports.BusIndexed = BusIndexed;